import { ApiTypeOfCare } from '../api-types/type-of-care.api';
import { NO_INTEGRATION_OFFICE, TypeOfCare } from '../app-types/type-of-care';

/**
 * Transforms an ApiTypeOfCare object to an app-specific TypeOfCare object.
 * @description This function maps properties of the ApiTypeOfCare to the TypeOfCare interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiTypeOfCare
 * @returns TypeOfCare
 */
export const transformApiTypeOfCareToAppTypeOfCare = (input: ApiTypeOfCare) => {
	const output: TypeOfCare = {
		id: input.id,
		integrationOfficeId: input.integrationOfficeId ?? NO_INTEGRATION_OFFICE,
		remark: input.remark,
		initial: input.initial,
	};
	return output;
};

/**
 * Transforms an array of ApiTypeOfCare objects to an array of app-specific
 * TypeOfCare objects.
 * @param input Array of ApiTypeOfCare objects
 * @description Transforms an array of ApiTypeOfCare objects to an array of app-specific TypeOfCare objects.
 * @returns Array of app-specific TypeOfCare objects
 */
export const transformApiTypesOfCareToAppTypesOfCare = (input: ApiTypeOfCare[]) => {
	const output: TypeOfCare[] = input.map(transformApiTypeOfCareToAppTypeOfCare);
	return output;
};
